export default __webpack_public_path__ + "static/media/fw-victoria-er-Rose Gold.a75a63a4.mp4";